import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from '../api';
import AdvancedSearch from '../components/AdvancedSearch';

function SearchResults() {
  const [searchParams] = useSearchParams();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [totalResults, setTotalResults] = useState(0);

  useEffect(() => {
    const fetchResults = async () => {
      try {
        setLoading(true);
        setError('');
        
        const response = await api.get('/posts/search', {
          params: {
            q: searchParams.get('q')
          }
        });

        setPosts(response.data.posts);
        setTotalResults(response.data.total);
      } catch (error) {
        console.error('Search error:', error);
        setError('Error fetching search results. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (searchParams.get('q')) {
      fetchResults();
    } else {
      setLoading(false);
      setPosts([]);
      setTotalResults(0);
    }
  }, [searchParams]);

  return (
    <div className="container mx-auto px-4 py-8">
      <AdvancedSearch />

      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-2">Search Results</h1>
        {totalResults > 0 && (
          <p className="text-gray-600">Found {totalResults} results</p>
        )}
      </div>

      {loading ? (
        <div className="text-center py-8">Loading...</div>
      ) : error ? (
        <div className="text-red-500 text-center py-8">{error}</div>
      ) : posts.length > 0 ? (
        <div className="space-y-6">
          {posts.map(post => (
            <article key={post._id} className="border rounded-lg p-6 hover:shadow-md transition">
              <Link to={`/post/${post._id}`}>
                <h2 className="text-xl font-semibold mb-2 hover:text-blue-600">
                  {post.title}
                </h2>
              </Link>
              <p className="text-gray-600 mb-4">
                {post.content.substring(0, 200)}...
              </p>
              <div className="flex items-center text-sm text-gray-500">
                <span>By {post.author?.name || 'Unknown'}</span>
                <span className="mx-2">•</span>
                <span>{new Date(post.createdAt).toLocaleDateString()}</span>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-600">
          {searchParams.get('q') 
            ? 'No results found. Try a different search term.'
            : 'Enter a search term to find posts.'}
        </div>
      )}
    </div>
  );
}

export default SearchResults; 